"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mountIsland_1 = require("../mountIsland");
var LastTransaction_1 = __importDefault(require("./LastTransaction"));
var LastTransactionContext_1 = require("./LastTransactionContext");
var element = document.getElementById('donation-thank-you');
if (element) {
    (0, mountIsland_1.mountIsland)(element, react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(LastTransactionContext_1.LastTransactionProvider, null,
            react_1.default.createElement(LastTransaction_1.default, null))));
}
